<template>
    <div id="LmTextInputBuilderUi" class="row">
      <LmTextInput
        ref="inputFocus"
        class="col-12 col-md-4"
        v-model="component.componentProps.label"
        @input="$emit('input', component)"
        label="Label"
        placeholder="Label"
      />
      <LmTextInput
        class="col-12 col-md-4"
        v-model="component.formObjectToSendToServerProperty"
        @input="$emit('input', component)"
        label="Nombre"
        placeholder="Nombre"
      />
      <LmTextInput
        class="col-12 col-md-4"
        v-model="component.componentProps.placeholder"
        @input="$emit('input', component)"
        label="placeholder"
        placeholder="placeholder"
      />
      <LmSelect
        :id="id + 'css'"
        class="col-12 col-md-4"
        v-model="component.class"
        :options="{
          content: [
            {value: 'col-12 col-md-3',text: '25%'},
            {value: 'col-12 col-md-6', text: '50%'},
            {value: 'col-12 col-md-9', text: '75%'},
            {value: 'col-12 col-md-12', text: '100%'}
          ]
        }"
        label="Ancho"
        :help="$t('help_width_form_element')"
        @input="$emit('input', component)"
      />
      <div class="col-12">
        <h5>Validation</h5>
        <div class="row align-items-center">
          <div class="custom-control custom-checkbox col-12 col-md mt-1">
            <b-form-checkbox
              :name="component.formObjectToSendToServerProperty"
              v-model="validations.required"
              @input="$emit('validations-changes', {[component.formObjectToSendToServerProperty]:validations})"
              >
              Required
            </b-form-checkbox>
          </div>
          <div class="custom-control custom-checkbox col-12 col-md mt-1">
            <b-form-checkbox
              :name="component.formObjectToSendToServerProperty"
              v-model="validations.email"
              @input="$emit('validations-changes', {[component.formObjectToSendToServerProperty]:validations})"
              >
              Email
            </b-form-checkbox>
          </div>
        </div>
      </div>
      <LmConditionalBuilderUi
        v-if="isVisibleCondition"
        class="col-12"
        :id="id"
        :leftValueToCompareOptions="leftValueToCompareOptions"
        :visibilityDependOnConditions="visibilityDependOnConditions"
        @changeVisibilityDependOnConditions="component.visibilityDependOnConditions = $event"
        @input="$emit('input', component)"
        />
      <LmConditionalByEditModeBuilderUi
        :component="component"
        @input="$emit('input', component)"
        />
    </div>
</template>

<script>
import lmFormElementsBuilderUiMixin from '@/mixins/lmFormElementsBuilderUiMixin.js'
export default {
  mixins: [lmFormElementsBuilderUiMixin],
  data () {
    return {
      validations: {
        required: false,
        email: false
      }
    }
  },
  props: {
    isVisibleCondition: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    // Cada vez que actualizo el name, recargo las validaciones con el nuevo name
    'component.formObjectToSendToServerProperty' (newVal) {
      this.$emit('validations-changes', { [newVal]: this.validations })
    }
  },
  created () {
    /*
      En el Mixin LmFormElementsBuilderUiMixin.js pisa el data de este
      componente impidiendo setear las variables por defecto.
      Lo soluciono con este bloque para que la validacion "email" este checked por defecto.
    */
    if (!this.validations.hasOwnProperty('email')) {
      this.validations.email = true
      this.$emit('validations-changes', { [this.component.formObjectToSendToServerProperty]: this.validations })
    }
  }
}
</script>
